import {
  CancelButton,
  Error,
  InputForm,
  SelectForm,
  SubmitButton,
} from "components";
import { DcddUserInput, DcddUserInputError } from "../../../state/actionType";
import { useEffect, useState } from "react";
import { DcddRegistrationCategory } from "props/enum";
import HomeForm from "./HomeForm";
import EcddForm from "./EcddForm";
import StudenForm from "./StudentForm";
import TeacherForm from "./TeacherForm";
import FacilitatorForm from "./FacilitatorForm";
import { connect } from "react-redux";
import {
  fetchDzongkhag,
  fetchEccd,
  fetchGrades,
  fetchSchools,
} from "../../../state/action";

interface FormProps {
  header: string;
  isUpdate?: boolean;
  loading: boolean;
  formData: DcddUserInput;
  error: DcddUserInputError;
  onClose?: () => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
const DcddUserForm: React.FC<Props> = ({
  handleChange,
  handleSubmit,
  error,
  formData,
  loading,
  header,
  onClose,
  onFetchDzongkhag,
  onFetchEccd,
  onFetchGrades,
  onFetchSchools,
  fetchDcddState,
  isUpdate
}) => {
  const [selectedGender, setSelectedGender] = useState<
    "Male" | "Female" | "Other" | ""
  >(() => {
    if (formData.gender === "Male" || formData.gender === "Female") {
      return formData.gender;
    } else if (formData.gender) {
      return "Other";
    } else {
      return "";
    }
  });

  const [customGender, setCustomGender] = useState(() => {
    if (
      formData.gender !== "Male" &&
      formData.gender !== "Female" &&
      formData.gender
    ) {
      return formData.gender;
    } else {
      return "";
    }
  });
  useEffect(() => {
    onFetchDzongkhag();
    onFetchGrades();
  }, [onFetchDzongkhag, onFetchGrades]);
  useEffect(() => {
    if (formData.dzongkhag_id) {
      onFetchEccd(formData.dzongkhag_id);
      onFetchSchools(formData.dzongkhag_id);
    }
  }, [formData.dzongkhag_id, onFetchEccd, onFetchSchools]);
  const dzongkhag = fetchDcddState?.fetchDzongkhag;
  const school = fetchDcddState?.fetchSchool;
  const eccd = fetchDcddState?.fetchEccd;
  const grade = fetchDcddState?.fetchGrade;

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-center">{header}</h2>
      <form className="">
        <div>
          <InputForm
            type="text"
            styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
            label="Name"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {error.name && <Error>{error.name}</Error>}
        </div>
        <div className="mb-4">
          <label className="block font-medium mb-1">Gender</label>
          <div className="flex gap-4">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="gender"
                value="Male"
                checked={selectedGender === "Male"}
                onChange={(e) => {
                  setSelectedGender("Male");
                  handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "gender",
                      value: "Male",
                    },
                  });
                }}
              />
              Male
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="gender"
                value="Female"
                checked={selectedGender === "Female"}
                onChange={(e) => {
                  setSelectedGender("Female");
                  handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "gender",
                      value: "Female",
                    },
                  });
                }}
              />
              Female
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="gender"
                value="Other"
                checked={selectedGender === "Other"}
                onChange={(e) => {
                  setSelectedGender("Other");
                  setCustomGender("");
                  handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "gender",
                      value: "",
                    },
                  });
                }}
              />
              Other
            </label>
          </div>
          {selectedGender === "Other" && (
            <div className="mt-2">
              <input
                type="text"
                name="customGender"
                placeholder="Please specify"
                value={customGender}
                onChange={(e) => {
                  setCustomGender(e.target.value);
                  handleChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: "gender",
                      value: e.target.value,
                    },
                  });
                }}
                className="border border-gray-300 rounded px-2 py-2 w-2/5 text-sm"
              />
            </div>
          )}
          {error.gender && <Error>{error.gender}</Error>}
        </div>
        <div className="pb-3">
          <SelectForm
            styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
            label="Category"
            type="text"
            id="category"
            name="category"
            value={formData?.category}
            option={Object.values(DcddRegistrationCategory).map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
            onChange={handleChange}
          />
          {error?.category && <Error>{error?.category}</Error>}
        </div>
        {formData.category === DcddRegistrationCategory.ECCD && (
          <EcddForm
            formData={formData}
            dzongkhagData={dzongkhag}
            eccdData={eccd}
            error={error}
            handleChange={handleChange}
          />
        )}

        {formData.category === DcddRegistrationCategory.HOME && (
          <HomeForm
            dzongkhagData={dzongkhag}
            formData={formData}
            error={error}
            handleChange={handleChange}
          />
        )}

        {formData.category === DcddRegistrationCategory.STUDENT && (
          <StudenForm
            dzongkhagData={dzongkhag}
            schoolData={school}
            gradeData={grade}
            formData={formData}
            error={error}
            handleChange={handleChange}
          />
        )}
        {formData.category === DcddRegistrationCategory.DZONGKHA_TEACHER && (
          <TeacherForm
            dzongkhagData={dzongkhag}
            schoolData={school}
            formData={formData}
            error={error}
            handleChange={handleChange}
          />
        )}
        {formData.category === DcddRegistrationCategory.ECCD_FACILITATOR && (
          <FacilitatorForm
            dzongkhagData={dzongkhag}
            eccdData={eccd}
            formData={formData}
            error={error}
            handleChange={handleChange}
          />
        )}
        {formData.category && !isUpdate && (
          <div>
            <InputForm
              type="text"
              styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
              label="Password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {error.password && <Error>{error.password}</Error>}
          </div>
        )}
      </form>

      {/* Submit Button */}
      <div className="mt-6 flex justify-between">
        <div>
          <CancelButton type="button" onClick={onClose} />
        </div>
        <div>
          <SubmitButton onClick={handleSubmit} loading={loading} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  fetchDcddState: state.dcddUser.dcddUserState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchDzongkhag: () => dispatch(fetchDzongkhag()),
  onFetchGrades: () => dispatch(fetchGrades()),
  onFetchSchools: (dzongkhag_id: string) =>
    dispatch(fetchSchools(dzongkhag_id)),
  onFetchEccd: (dzongkhag_id: string) => dispatch(fetchEccd(dzongkhag_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DcddUserForm);
